module.exports = __webpack_public_path__ + "img/logo.d718a9a3.png";